var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{attrs:{"color":"#303030","flat":""}},[_c('router-link',{staticClass:"logo-link",attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo_red.svg")}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }